<div class="dialog-wrapper">
    <div class="headers">
<p class="headings">JEE Mains Rookie Not Applied</p>
<img class="icon"src="../assets/image/closeMark.svg"
 alt="Close"
      (click)="onClose()"
      style="cursor: pointer;"/>

    </div>
    <hr>

<div class="bothParams">
  <div class="programDtails">
    <p class="program">Program Name : </p>
    <p class="programData">{{data.program}}</p>
  </div>
    <div class="classDetails">
 <p class="className">ClassName :</p>
 <p class="classData">{{className}}</p>
    </div>
    
</div>
<ag-grid-angular
        style="
          width: 94%;
          margin-top: 17px;
          margin-left: 20px;
          margin-bottom: 20px;
        "
        class="ag-theme-alpine"
        [rowData]="rowData1"
        [columnDefs]="columnDefs1"
        [defaultColDef]="defaultColDef"
        domLayout="autoHeight">
      </ag-grid-angular>
<div>

</div>
  
</div>
        <!-- <p>{{data.program}}</p> -->